import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {FormControl, InputLabel, Select, MenuItem, FormHelperText, TextField } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 120
    },
}));

const Selector = ({ label, name, value, data, onChange, displayProperty, keyProperty, required,error,helperText,defaultValue, ...restProps }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleChange = (e) => {
        if(onChange) onChange(e);
    }

    return (
        <TextField 
            className={classes.formControl} 
            required={ required }
            error={error}
            name={name}
            open={open}
            onClose={handleClose}
            onOpen={handleOpen}
            onChange={handleChange}
            defaultValue={defaultValue}
            value={value}
            select
            label={label}
            {...restProps}

        >
            <MenuItem value="" disabled><em>Select an option...</em></MenuItem>
            {data.map((item, index) => {
                return (
                        displayProperty instanceof Function ?
                        (
                            <MenuItem key={index} value={item[keyProperty]}>{displayProperty(item)}</MenuItem>
                        ):
                        (
                            <MenuItem key={index} value={item[keyProperty]}>{item[displayProperty]}</MenuItem>
                        )
                )
            })
            }
            {error ? (<FormHelperText>{helperText}</FormHelperText>) : null}
        </TextField>
     )
}

export default Selector;


// WEBPACK FOOTER //
// ./src/components/Common/Selector/Selector.js